import { Alert, Grid } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { observer } from 'mobx-react-lite'

interface Props {
  duplicatedAssignments: string[]
  type: 'blocks' | 'vessels' | 'trains'
}

export const OperationalEquipmentDuplicatedAlert = observer(
  ({ duplicatedAssignments, type }: Props) => {
    const { t } = useTranslate()

    if (!duplicatedAssignments.length) return <></>

    return (
      <Grid size={12} sx={{ display: 'flex', justifyContent: 'center' }}>
        <Alert severity='warning'>
          {t(
            'duplicatedAssignmentsNotAllowed',
            'You have already assigned the {type} {duplicatedItems} please review the assignment to prevent duplication',
            {
              duplicatedItems: duplicatedAssignments.join(', '),
              type: t(type, type),
            },
          )}
        </Alert>
      </Grid>
    )
  },
)
